import { On3IconAlert, On3IconTransferRating } from '@on3/icons';
import { Check } from '@on3/ui-lib/components/Svg';
import { EarlyEnrolleeIcon } from 'components/Icons/EarlyEnrolleeIcon';
import { EarlySigneeIcon } from 'components/Icons/EarlySigneeIcon';
import { AthleteVerified } from 'components/UI/AthleteVerified/AthleteVerified';
import { Text } from 'components/UI/Typography/Text';

import styles from './InterestLegend.module.scss';

export const InterestLegend = () => {
  return (
    <ul className={styles.legendWrapper}>
      <li className={styles.legendRow}>
        <EarlyEnrolleeIcon className={styles.icon} />
        <Text className={styles.legendText} variant="caption">
          Early enrollee
        </Text>
      </li>
      <li className={styles.legendRow}>
        <EarlySigneeIcon className={styles.icon} />
        <Text className={styles.legendText} variant="caption">
          Early signee
        </Text>
      </li>
      <li className={styles.legendRow}>
        <Check className={styles.checkmark} />
        <Text className={styles.legendText} variant="caption">
          Signed letter of intent
        </Text>
      </li>
      <li className={styles.legendRow}>
        <AthleteVerified />
        <Text className={styles.legendText} variant="caption">
          Elite Verified
        </Text>
      </li>
      <li className={styles.legendRow}>
        <On3IconAlert />
        <Text className={styles.legendText} variant="caption">
          Short-term Signee
        </Text>
      </li>
      <li className={styles.legendRow}>
        <On3IconTransferRating />
        <Text className={styles.legendText} variant="caption">
          Transfer Rating
        </Text>
      </li>
    </ul>
  );
};
